import styled from 'styled-components';
import { SIDEBAR_MOBILE_BREAKPOINT } from '@constants/sidebar';

export const Slot = styled.span`
  display: none;

  @media (max-width: ${SIDEBAR_MOBILE_BREAKPOINT}px) {
    display: flex;
    flex-shrink: 0;
    /* Pulls the button into the top bar's 28px left padding so it sits 16px from the edge. */
    margin-left: -12px;
  }
`;
